import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Loader from "../../components/Loader"
import PageContent from "../../components/PageContent"
import Search from "../../components/Search"
import Section from "../../components/Section"
import SectionTitle from "../../components/SectionTitle"
import { useNotification } from "../../context/notification"
import { DashboardLayout } from "../../layouts/DashboardLayout"
import { apiRequest } from "../../utils/api"
import getUserIP, { formatIPJSON } from "../../utils/getUserIP"
import useDocumentTitle from "../../utils/useDocumentTitle"
import BulkTable from "./components/BulkTable"
import styles from "./Settings.module.scss"

const CampaignManagement = (props) => {
  useDocumentTitle(props.title)
  const { t } = useTranslation()
  const { addNotification } = useNotification();
  const [campaignData, setCampaignData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchKey, setSearchKey] = useState("")
  const [sort, setSort] = useState({
    columnName: "",
    order: ""
  })
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0
  })
  const [selected, setSelected] = useState([]);


  const tableHeaderObj = [
    { name: "functional_unit", label: t("campaignManagement.functionUnit"), sortable: true },
    { name: "sub_functional_unit", label: t("campaignManagement.subFunctionUnit"), sortable: true },
    { name: "region_name", label: t("campaignManagement.regionName"), sortable: false },
    { name: "email_otp_enabled", label: t("campaignManagement.emailOtp"), sortable: false, type: "status", listview: "campaign_management"},
    { name: "ext_link_enabled", label: t("campaignManagement.extLink"), sortable: false, type: "status" },
  ]

  async function fetchData() {
    setIsLoading(true)

    const response = await apiRequest.get(`/api/getAllCampaigns?view=campaign_management&page=${pagination.page}&pageSize=${pagination.pageSize}&search=${searchKey}&columnName=${sort.columnName}&order=${sort.order}&use_pagination=true`)

    if (response.status == 200) {
      const data = response.data
      setCampaignData(data.data)
      const apiPagination = data.pagination
      setPagination(prev => ({
        ...prev,
        page: apiPagination.page,
        pageSize: apiPagination.pageSize,
        total: apiPagination.total
      }))
    }

    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [searchKey, pagination.page, pagination.pageSize, sort.columnName, sort.order])

  const handleBulkUpdate = async (selected, config) => {
    try {
      const campaigns = []

      for (const s of selected) {
        const row = campaignData.find(r => r.campaign_id == s.campaign_id)

        const campaign = {
          functionalUnit: row.functional_unit,
          subfunctionalUnit: row.sub_functional_unit,
          emailOtpEnabled: s.email_otp_enabled,
          extLinkEnabled: s.ext_link_enabled
        }
        campaigns.push(campaign)
      }

      const userIp = await getUserIP();

      const response = await apiRequest.post("/api/campaign/config", { campaigns: campaigns, userIp: formatIPJSON(userIp) })

      const data = response.data.data

      if (data.status == "success") {
        await fetchData()
        return true;
      }
    } catch (error) {
      addNotification(error.response.data.error ?? t("error.internalServerError"), "error")
    }
  }

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <SectionTitle>{t("leftNavigation.campaignManagement")}</SectionTitle>
            </div>
            <div className={styles.searchWrapper}>
              <Search fullWidth handleSearch={val => { setSearchKey(val) }} />
            </div>
            {isLoading ? <Loader /> :
              <BulkTable
                tableHeaderObj={tableHeaderObj}
                data={campaignData}
                bulkUpdateFunction={handleBulkUpdate}
                title="Campaign"
                selected={selected}
                setSelected={setSelected}
                pagination={pagination}
                setPagination={setPagination}
                sort={sort}
                setSort={setSort}
              />
            }
          </Section>
        </PageContent>

      </div>
    </DashboardLayout>
  )
}

export default CampaignManagement